import React from 'react'
import { array, string } from 'prop-types'
import Type from '@/component/Primitive/Type'
import styles from './ProfileTag.module.scss'
import cx from 'classnames'

const ProfileTag = ({ value, label, className, classNames }) => {
  return (
    <div className={cx(styles.ProfileTag, className)}>
      {label && (
        <Type
          as="span"
          size={['body4', 'body3']}
          weight="medium"
          className={cx(styles.LabelWrapper, classNames?.labelWrapper)}
        >
          {label}
        </Type>
      )}
      <Type
        as="span"
        size={['body4', 'body3']}
        className={cx(styles.Value, classNames?.value)}
      >
        <span className={styles.inner}>{value}</span>
      </Type>
    </div>
  )
}

ProfileTag.propTypes = {
  value: string.isRequired,
  label: string,
  className: string,
  classNames: array
}

export default ProfileTag
